
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/discontinued/[index]",
      function () {
        return require("private-next-pages/products/discontinued/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/discontinued/[index]"])
      });
    }
  